import { withContext } from '../Context'
import TestScoreSelectorWithSubjects, { Subject } from './TestScoreSelectorWithSubjects'

const PSAT_NMSQT_SUBJECTS: Subject[] = [
  { name: 'NMSQTMath', label: 'Math', min: 160, max: 760, rangeStep: 10 },
  { name: 'NMSQTReadingWriting', label: 'Reading & Writing', min: 160, max: 760, rangeStep: 10 },
]

type PSATNMSQTScoreSelectorProps = {
  criteria: string
  onChange: (criteria: string, segmentName: string, value: any, operation: string) => void
  segment: object
  isSubjectTestsEnabled?: boolean
}

export const PSATNMSQTScoreSelector = (props: PSATNMSQTScoreSelectorProps) => {
  return (
    <TestScoreSelectorWithSubjects
      {...props}
      testLabel="PSAT/NMSQT"
      totalScoreSegmentName="PSATNMSQT"
      totalScoreMin={320}
      totalScoreMax={1520}
      totalScoreStep={10}
      subjects={PSAT_NMSQT_SUBJECTS}
    />
  )
}

export default withContext(PSATNMSQTScoreSelector)
